import React from 'react';
import { Typography, Stack, TextField } from '@mui/material';
import SectionPaper from '../../../common/components/styled-ui-elements/SectionPaper';
import { useAppSelector } from '../../../../app/store';

export const PatientInfoView: React.FC = () => {
  const { currentWriteoff } = useAppSelector(state => state.writeoff);

  // Helper function to format date
  const formatDate = (dateString: string | undefined | null) => {
    if (!dateString) return '';
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return '';
    }
  };

  const inputSlotProps = {
    input: {
      readOnly: true,
      sx: { backgroundColor: '#f1f5f9' }
    }
  };

  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        Patient Information
      </Typography>
      <Stack direction="row" spacing={2}>
        <TextField
          label="Account #"
          value={currentWriteoff?.identifiers?.accountNumber || ''}
          size="small"
          disabled
          fullWidth
          sx={{ flex: 0.8 }}
          slotProps={inputSlotProps}
        />
        <TextField
          label="Patient Name"
          value={`${currentWriteoff?.patient?.firstName || ''} ${currentWriteoff?.patient?.lastName || ''}`.trim()}
          size="small"
          disabled
          fullWidth
          sx={{ flex: 1.2 }}
          slotProps={inputSlotProps}
        />
        <TextField
          label="Service Date"
          value={formatDate(currentWriteoff?.patient?.serviceDate)}
          size="small"
          disabled
          fullWidth
          sx={{ flex: 0.7 }}
          slotProps={inputSlotProps}
        />
        <TextField
          label="Payer"
          value={currentWriteoff?.patient?.payerName || ''}
          size="small"
          disabled
          fullWidth
          sx={{ flex: 1.5 }}
          slotProps={inputSlotProps}
        />
      </Stack>
    </SectionPaper>
  );
};

export default PatientInfoView;
